import React from 'react';
import PropTypes from 'prop-types';

import Footer from '../../components/Footer';
import Loading from '../../components/Loading';
import PatientImage from '../../components/PatientImage/PatientImage';

const FormBase = props => {
  return (
    <div className={ props.customClass }>
      { props.children }
      <PatientImage />
      <Footer />
      <Loading active={ props.isLoading } />
    </div>
  );
};

FormBase.propTypes = {
  environment: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  customClass: PropTypes.string,
};

export default FormBase;
